"use strict";
/**
 * Example usage:
 *
 * import admin from 'firebase-admin';
 * import {DocumentReference} from 'firebase/firestore';
 *
 * class Foo extends Model {
 *    name: string;
 * }
 *
 * // Using the admin SDK
 * type FooDocAdmin = DocumentModel<typeof Foo, admin.firestore.DocumentReference>;
 *
 * // Using the public web SDK
 * type FooDocWeb = DocumentModel<typeof Foo, DocumentReference>;
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDocumentModel = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
/**
 * Loads the given `model` using data from the supplied Firestore document
 * `doc` and returns a hybrid object that is an instance of the supplied
 * `model` merged with the document's ID and ref.
 */
const createDocumentModel = (model, snap, opts = { throw: true }) => {
    const item = model.raw(snap.data(), { silent: true });
    const errors = (0, toccata_1.getErrors)(item);
    if (errors.length > 0) {
        // eslint-disable-next-line no-console
        console.error(`Invalid document at path: ${snap.ref.path}`, errors);
        if (opts.throw) {
            throw new toccata_1.ValidationError(errors);
        }
    }
    Object.defineProperties(item, {
        _id: { value: snap.id, writable: false, enumerable: false },
        _ref: { value: snap.ref, writable: false, enumerable: false },
        _valid: { value: errors.length === 0, enumerable: false },
        _errors: { value: errors, enumerable: false },
    });
    return item;
};
exports.createDocumentModel = createDocumentModel;
//# sourceMappingURL=index.js.map